'use strict';

var y = require('yup');

function _interopNamespaceCompat(e) {
  if (e && typeof e === 'object' && 'default' in e) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'near';
const NEAR_ERROR = 'near';
/**
 * Taken directly from official NEAR JS SDK.
 * Https://github.com/near/near-sdk-js/blob/8c579d5045710f9822c378ed9d1c3b9fb13f488c/packages/near-sdk-js/src/utils.ts#L39.
 */ const ACCOUNT_ID_REGEX = /^(([a-z\d]+[-_])*[a-z\d]+\.)*([a-z\d]+[-_])*[a-z\d]+$/;
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: options?.error ?? NEAR_ERROR
        },
        test: (value)=>{
            return value.length >= 2 && value.length <= 64 && ACCOUNT_ID_REGEX.test(value);
        }
    });
});

exports.NEAR_ERROR = NEAR_ERROR;
//# sourceMappingURL=near.js.map
